import { Typography, Row, Col } from "antd";
import "./ProductDetailsVersion.css";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ReactComponent as BackButton } from "../../../../assests/back-arrow.svg";
import ProductDetailsCard from "./ProductDetailsCard";
import { RESET_SINGLE_PRODUCT } from "../../../../store/slices/common-slice/products/ProductSlice";
const { Text } = Typography;

const MobileProductDetails = () => {
  const location = useLocation();
  const isBillboard = location.state?.isBillboard;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const onBack = () => {
    dispatch(RESET_SINGLE_PRODUCT());
    navigate(location.pathname, { replace: true, state: {} });
    navigate(-1);
  };

  return (
    <>
      <div>
        <div className="product-details-main-div">
          <div className="product-details-arrow-and-text-div">
            <Row
              className="product-details-arrow-and-text-row"
              gutter={[16, 16]}
            >
              <Col className="product-details-back-button-details">
                <BackButton
                  size="small"
                  className="back-button-rfp-version"
                  onClick={onBack}
                />
              </Col>
              <Col>
                <Text className="submit-an-rfp-version-text">
                  Product Details
                </Text>
              </Col>
            </Row>
          </div>
          <ProductDetailsCard
            productId={location?.state?.product?.id}
            isBillboard={isBillboard}
          />
        </div>
      </div>
    </>
  );
};
export default MobileProductDetails;
